export default "__VITE_ASSET__zKaOJpFv__"